import React, { Fragment } from 'react'

import IOSSDK from '@/docs-partials/sdk/ios.mdx'
import AndroidSDK from '@/docs-partials/sdk/android.mdx'
import GRID from '@/docs-partials/sdk/grid.mdx'
import WebSDK from '@/docs-partials/sdk/web.mdx'
import ReactNativeSDK from '@/docs-partials/sdk/react-native.mdx'
import GuideSDK from '@/docs-partials/sdk/guide.mdx'
import DataCollectionSDK from '@/docs-partials/sdk/data-collection.mdx'
import ContentTypeSDK from '@/docs-partials/sdk/content-types.mdx'
import OverviewSDK from '@/docs-partials/sdk/overview.mdx'
import { DocsSection } from '@/components/common/docs-section'

const OptionalSettings = () => {
  return (
    <Fragment>
      <div className="docsContainer">
        <OverviewSDK />
        <DocsSection anchorId="content-types">
          <ContentTypeSDK />
        </DocsSection>
        <DocsSection anchorId="grid">
          <GRID />
        </DocsSection>
        <DocsSection anchorId="ios">
          <IOSSDK />
        </DocsSection>
        <DocsSection anchorId="android">
          <AndroidSDK />
        </DocsSection>
        <DocsSection anchorId="web">
          <WebSDK />
        </DocsSection>
        <DocsSection anchorId="react-native">
          <ReactNativeSDK />
        </DocsSection>
        <DocsSection anchorId="design-guidelines">
          <GuideSDK />
        </DocsSection>
        <DocsSection anchorId="data-collection">
          <DataCollectionSDK />
        </DocsSection>
      </div>
    </Fragment>
  )
}

export default OptionalSettings
